/* ── Abrir o menu "Shop" no CLIQUE ────────────────────────────────────────
   A referencia monta o item de menu com submenu como `<details class=
   "mega-menu"><summary>Shop</summary>…`: clicar abre, clicar de novo fecha, e
   passar o mouse NAO abre. O Horizon faz o contrario — o painel
   (`.menu-list__submenu`) e revelado por CSS de hover, e o proprio "Shop" e um
   link para /collections/best-sellers, entao clicar saia da pagina.

   Aqui o clique passa a mandar: ele segura a navegacao do link que tem
   submenu, marca o item com `ewc-menu-aberto` (a folha comum cuida do resto) e
   fecha o que estiver aberto. Clique fora, Escape e troca de item fecham.
   Item de menu SEM submenu continua sendo um link normal.

   Atualizado em 2026-10-11: o painel do Horizon nasce com `inert`, e quem o
   tirava e devolvia eram os gatilhos de ponteiro do item (`/activate` e
   `/deactivate`). Esses gatilhos sairam do bloco: abriam no hover e, pior, o
   `pointerleave` devolvia o `inert` assim que o mouse descia pela folga entre o
   rotulo e a primeira fileira — o painel seguia visivel e os links paravam de
   responder. Agora e este script que cuida dos dois atributos que o tema le:
   `inert` (`.header__row:has(.menu-list__submenu:not([inert]))` eleva a fileira
   do cabecalho) e `data-active` (desliga o `content-visibility: auto` do
   painel). */
(function () {
  'use strict';
  if (window.EwcNav) return;
  window.EwcNav = true;

  var ABERTO = 'ewc-menu-aberto';
  var ITEM = '.menu-list__list-item';
  var GATILHO = '.menu-list__link, .menu-list__trigger';
  var PAINEL = '.menu-list__submenu, .mega-menu';

  function todos() {
    return Array.prototype.slice.call(document.querySelectorAll(ITEM + '.' + ABERTO));
  }

  /* um so lugar escreve o estado: classe, aria e os dois atributos do tema */
  function marcar(li, aberto) {
    li.classList.toggle(ABERTO, aberto);
    var valor = aberto ? 'true' : 'false';
    var l = li.querySelector('.menu-list__link');
    if (l) l.setAttribute('aria-expanded', valor);
    var d = li.querySelector('.menu-list__disclosure');
    if (d) d.setAttribute('aria-expanded', valor);
    var p = li.querySelector('.menu-list__submenu');
    if (!p) return;
    if (aberto) {
      p.removeAttribute('inert');
      p.setAttribute('data-active', '');
    } else {
      p.setAttribute('inert', '');
      p.removeAttribute('data-active');
    }
  }

  function fechar(exceto) {
    todos().forEach(function (li) {
      if (li !== exceto) marcar(li, false);
    });
  }

  document.addEventListener('click', function (e) {
    var gatilho = e.target.closest && e.target.closest(GATILHO);
    if (gatilho) {
      var li = gatilho.closest(ITEM);
      /* so intercepta quem TEM submenu: os outros seguem o link */
      if (li && li.querySelector(PAINEL)) {
        e.preventDefault();
        e.stopPropagation();
        var abrindo = !li.classList.contains(ABERTO);
        fechar(li);
        marcar(li, abrindo);
      }
      return;
    }
    /* clique dentro do painel aberto e navegacao de verdade; fora, fecha */
    if (!(e.target.closest && e.target.closest(PAINEL))) fechar(null);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') fechar(null);
  });
})();
